import { useQuery } from "@tanstack/react-query";
import { Permission } from "../types/user.types";
import { apiGet } from "../helpers/request.helpers";

export function useUserPermissions(userId?: number) {
  return useQuery<Permission[], Error>({
    queryKey: ["user-permissions", userId],
    queryFn: async () =>
      await apiGet("/admin/get-user-permissions", { userid: userId }),
    enabled: !!userId,
  });
}
